import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { Config } from "../common";
import { UserRoles } from "../common/constants/UserRoles";
import { setIsLoggedIn, updateUserInfo } from "../redux/User";
import AppCategory from "./AppCategory";
import AppTag from "./AppTag";
import Category from "./Category";
import NotificationWorkFlowMapping from "./NotificationWorkFlowMapping";
import PageUrl from "./PageUrl";
import PageUrlCategory from "./PageUrlCategory";
import State from "./State";
import Tag from "./Tag";
import User from './User';

const Api = () => {
  const apiService = ApiService();
  return {
    state: State(apiService),
    user: User(apiService),
    pageUrl: PageUrl(apiService),
    notificationWorkflowMapping: NotificationWorkFlowMapping(apiService),
    category: Category(apiService),
    AppCategory: AppCategory(apiService),
    appTag: AppTag(apiService),
    tag: Tag(apiService),
    pageUrlCategory: PageUrlCategory(apiService)
  }
};

export default Api;

const ApiService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const post = (path: string, params: any, data: any) => send(path, 'POST', params, data);
  const put = (path: string, params: any, data: any) => send(path, 'PUT', params, data);
  const get = (path: string, params: any, data: any) => send(path, 'GET', params, data);
  const remove = (path: string, params: any, data: any) => send(path, 'DELETE', params, data);

  const send = (path: string, method: any, params: any, data: any) => {
    const baseUrl = Config.server.baseUrl;
    const url = `${baseUrl}${path}`;

    return new Promise((resolve, reject) => {

      const initialHeaders = {
        'Content-Type':
        data instanceof FormData ? 'multipart/form-data' : 'application/json',
        Accept: 'application/json',
      };
      const auth: any = localStorage.getItem('accessToken');
      const accessToken = auth ? JSON.parse(auth) : '';
      const additionalHeaders = accessToken
        ? { Authorization: `Bearer ${accessToken}`}
        : {};
      const headers = {...initialHeaders, ...additionalHeaders}

      const axiosArgs = Object.entries({url, method, headers, params, data})
        .filter((entry) => {
          const value = entry[1];
          if (value instanceof FormData) {
            return true;
          }
          const isEmptyObject =
            value != null &&
            typeof value === 'object' &&
            Object.keys(value).length === 0;
          return !isEmptyObject;
        })
        .reduce((acc, entry) => {
          const [key, value] = entry;
          return {...acc, [key]: value};
        }, {});

      axios(axiosArgs)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              logout();
            } else {
              console.log('error:::',error.response.data.message);
              toast.error(error.response.data.message);
              if (error.response.data.error_params) {
                error.response.data.error_params.forEach((e: any) => {
                  toast.error(e.msg);
                });
              }
            }
          } else if (error.request) {
            reject(createError('No Response from server', error.request));
          } else {
            reject(createError('Error processing request', error.message));
          }
        });
    });
  };

  const login = (email: string, password: string) => {
    return new Promise((resolve, reject) => {
      if (email === 'admin@jkchrome.com' && password === 'admin123') {
        const userInfo = {
          username: 'admin@jkchrome.com',
          roles: [UserRoles.ADMIN],
          fullName: 'JKChrome Admin',
        }
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          dispatch(updateUserInfo(userInfo));
              dispatch(setIsLoggedIn(true));
        resolve({
          message: 'Successfully Logged In.',
          data: userInfo,
        });
      } else {
        reject({
          message: 'Invalid Username or Password',
        });
      }
    });
  };

  const logout = async () => {
    await localStorage.removeItem('userInfo');
    dispatch(updateUserInfo({}));
    dispatch(setIsLoggedIn(false));
    navigate("/login");
  };

  return {
    post,
    get,
    put,
    remove,
    login,
    logout,
  };
};

const createError = (name: string, message: string) => {
  const error = new Error();
  error.name = name;
  error.message = message;
  return error;
};
